import styled, { css } from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { PremiumDialog } from '@root/shared/ui/premium-dialog'

import { UploadPremiumEmojiContent } from '../common/update-emoji-content'

import type { CurrencyModel } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium'
import type { ClassNameProps } from '@root/shared/react'
import type { DialogControlProps } from '@root/shared/ui-kit'

type Props = {
  currency: CurrencyModel
  premiumMeta: PremiumMetaModel
} & ClassNameProps &
  DialogControlProps

export const UpdateEmojiDialog: React.FC<Props> = ({
  className,
  open,
  onOpenChange,
  currency,
  premiumMeta,
  ...props
}) => {
  const { t } = useTranslation()
  return (
    <Root
      className={className}
      open={open}
      onOpenChange={onOpenChange}
      title={t('premium.update-emoji.title')}
      describedBy={t('premium.update-emoji.title')}
      onClose={() => {
        onOpenChange?.(false)
      }}
      {...props}
    >
      <UploadPremiumEmojiContent
        currency={currency}
        premiumMeta={premiumMeta}
        css={css`
          padding-bottom: 24px;
        `}
        onClose={() => {
          onOpenChange?.(false)
        }}
      />
    </Root>
  )
}

const Root = styled(PremiumDialog)``
